import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function exportDebtorsToPDF(debtors, filename = "debtors_report.pdf") {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  let currentY = 10;

  doc.setProperties({
    title: "Debtors Report",
    subject: "Customer Debtors Data Export",
    creator: "Afghan Cosmos Group",
  });

  const addHeader = () => {
    const shopName = "Afghan Cosmos ";

    try {
      const logoUrl = `${process.env.REACT_APP_IMAGE_URL}images/logo.jpeg`;
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = logoUrl;
      doc.addImage(img, "JPEG", pageWidth - 25, 2, 10, 10);
    } catch (error) {
      console.error("Failed to load logo:", error);
    }

    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(51, 102, 204);
    doc.text("Debtors Report", pageWidth / 2, 9, { align: "center" });

    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(80, 80, 80);
    doc.text(shopName, 10, 7);

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated: ${new Date().toLocaleDateString()}`, 10, 11);

    return 18;
  };

  currentY = addHeader();

  const totalAmount = debtors.reduce(
    (acc, row) => acc + (parseFloat(row.amount) || 0),
    0
  );
  const totalSettled = debtors.reduce(
    (acc, row) => acc + (parseFloat(row.settled_amount) || 0),
    0
  );
  const totalOutstanding = debtors.reduce((acc, row) => {
    const outstanding =
      row.outstanding_amount != null
        ? parseFloat(row.outstanding_amount)
        : (parseFloat(row.amount) || 0) - (parseFloat(row.settled_amount) || 0);
    return acc + (outstanding || 0);
  }, 0);

  autoTable(doc, {
    head: [
      [
        "#",
        "Customer",
        "Account",
        "Amount",
        "Settled",
        "Outstanding",
        "Currency",
        "Rate",
        "Converted",
        "Date",
        "Notes",
      ],
    ],
    body: debtors.map((row, index) => {
      const outstanding =
        row.outstanding_amount != null
          ? row.outstanding_amount
          : (parseFloat(row.amount) || 0) -
            (parseFloat(row.settled_amount) || 0);
      return [
        index + 1,
        row.customer_details?.name || "-",
        row.account_details?.name || "-",
        row.amount ?? "0.00",
        row.settled_amount ?? "0.00",
        Number(outstanding).toFixed(2),
        row.currency_details?.title || "-",
        row.exchange_rate ?? "-",
        row.converted_amount ?? "-",
        row.loan_date ? new Date(row.loan_date).toLocaleString() : "-",
        row.notes || "-",
      ];
    }),
    startY: currentY,
    styles: {
      fontSize: 7,
      cellPadding: 1.5,
      halign: "center",
      valign: "middle",
      lineColor: [220, 220, 220],
      lineWidth: 0.1,
    },
    headStyles: {
      fillColor: [51, 102, 204],
      textColor: 255,
      fontStyle: "bold",
      fontSize: 7,
    },
    alternateRowStyles: { fillColor: [245, 247, 250] },
    margin: { left: 8, right: 8 },
  });

  const finalY = doc.lastAutoTable.finalY + 8;
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(40, 40, 40);
  doc.text(`Total Amount: ${totalAmount.toFixed(2)}`, 10, finalY);
  doc.text(`Total Settled: ${totalSettled.toFixed(2)}`, 80, finalY);
  doc.text(`Total Outstanding: ${totalOutstanding.toFixed(2)}`, 150, finalY);

  doc.save(filename);
}
